export const en = {
    "k_1d5adde3": "Webhook",
    "k_357199e2": "The current page is developed in low code and does not support this mode",
    "k_e2fabe4a": "DB-Data Sheet",
    "k_5273f268": "Additions and deletions to search",
    "k_1dafe382": "DB-Executing SQL",
    "k_9a731279": "Execute SQL statements",
    "k_5d150a39": "DB-MySQL multi-table reading and writing",
    "k_7b4a81bf": "Multi-table transaction operations, associated queries",
    "k_33dc5b17": "DB-Cross-service Access",
    "k_52fbde01": "Access DB for other WUJI deployment versions",
    "k_ab1cb42d": "Single HTTP interface",
    "k_90b2a7d": "Request backend services",
    "k_e1b2f73b": "Multiple HTTP interface combinations",
    "k_28680282": "Request a set of backend services for additions, deletions, changes and inspections",
    "k_1652e773": "Online NodeJs interface",
    "k_aeb2ce06": "Write cloud functions online",
    "k_8b838246": "Multi-table",
    "k_28dcc801": "Cross-service access",
    "k_13b92170": "Data source management",
    "k_2ec141c4": "Search for name or ID",
    "k_282d84cd": "New data source",
    "k_d676fdb1": "Person in charge",
    "k_36a4e2bc": "Please enter the copied data source ID and confirm",
    "k_8435ee84": "Log",
    "k_e8aa1def": "Are you sure you want to delete this data source?",
    "k_426162fa": "No eligible data source",
    "k_1f8dc194": "Please add data sources",
    "k_de073575": "Replication successful, new ID: {arg_0}",
    "k_f57efe67": "Replication failed, the same ID already exists: {arg_0}",
    "k_aaebdce5": "Replication failed, error message: {arg_0}'",
    "k_d65486be": "Deleted successfully",
    "k_3bd4ac22": "Delete failed {arg_0}",
    "k_bbc6de30": "Failed to load data source {arg_0}",
    "k_f2356931": "Failed to load data source label {arg_0}",
    "k_2206a7e6": "{arg_0}AI Editor",
    "k_93284bb7": "WUJI application",
    "k_111e52a3": "The targetAppId parameter is incorrect",
    "k_a3d869a9": "Form verification failed",
    "k_f968ede0": "Authorization failure",
    "k_847607cc": "User actively closes pop-up window",
    "k_5e0498b": "Request failed",
    "k_e5b4fef4": "Unknown error, please close it and try again",
    "k_b171cc99": "Please enter database ID",
    "k_7922dffb": "Database ID can only contain letters, numbers, and underscores",
    "k_97ce6a09": "Please enter database name",
    "k_99100717": "Please enter database administrator",
    "k_b4eed97d": "Database ID",
    "k_158cb448": "Please enter the database ID, only letters, numbers and underscores can be used",
    "k_96fdcdad": "Database name",
    "k_ed37c1de": "Please enter the database name. It is recommended to enter a readable Chinese name",
    "k_94225d46": "Database description",
    "k_ccf8301f": "Administrator",
    "k_819549e0": "List interface",
    "k_f5cff5c8": "Original data structure",
    "k_22b32378": "Total number of inquiries",
    "k_f861ac6": "New interface",
    "k_eb511250": "Update interface",
    "k_74916e98": "Acquisition interface",
    "k_cbae8d48": "Delete interface",
    "k_edbdc2f2": "Current data structure",
    "k_3b4ee996": "Failed to create/update the knowledge base:",
    "k_738a9cf3": "Failed to obtain the knowledge base:",
    "k_e9ea39c9": "Failed to search the knowledge base:",
    "k_cdc43d07": "Failed to obtain project repository permissions: {arg_0}",
    "k_39f9ebaf": "Failed to add/update project knowledge base permissions:",
    "k_55130185": "Failed to delete project repository permissions:",
    "k_bfad681e": "Home page",
    "k_56c1a46e": "Branch merge parameter detected:",
    "k_ceb78fed": "Merge {arg_0} to {arg_1} branch",
    "k_4492a142": "AI project merge failed:",
    "k_8acd29ae": "Branch merge failed: {arg_0}",
    "k_ab08dc44": "Dependent build failed. Please open the console to view details",
    "k_6a45762e": "Compilation failed",
    "k_ae3a48e7": "File compilation failed. Are you sure you want to continue publishing?",
    "k_d84bdaaa": "Conflict resolved",
    "k_167b57af": "AI project merged successfully",
    "k_8c5c19ad": "AI page area",
    "k_7146ef43": "{arg_0} will be rendered at runtime ",
    "k_2615b7b0": "Perform an approval",
    "k_4aacd7d": "Withdraw (cancel approval)",
    "k_88a26373": "Comment",
    "k_bf1ff4b5": "Get all process sheets",
    "k_3b2b7508": "Search flow sheet by type",
    "k_e0d36f63": "For example: what I initiated, what I participated in, related to me, pending approval",
    "k_ba735eb9": "Pending",
    "k_8f78fe2d": "Deploying backend service, please wait a moment",
    "k_5ddc9a0e": "Backend services not deployed",
    "k_2d2025c4": "Already logged in, please try again",
    "k_a9840375": "Server logic has changed",
    "k_af1a0fd6": "Code changes detected, checking deployment status...",
    "k_365d2479": "Back-end service deployment",
    "k_273a0b56": "Creating a new backend service...",
    "k_23f1a5fd": "Back-end service deployment failed",
    "k_58a12523": "Deployment failed. Please check the code or redeploy",
    "k_99a7219d": "Successfully deployed",
    "k_55e935eb": "Back-end services are ready",
    "k_4b8ce8a6": "You need to save it first to see the effect.",
    "k_50bff2d1": "Still continue",
    "k_d080ede": "Backend logic has changed. Continuing may produce dirty data.",
    "k_322e8507": "Backend logic has changed",
    "k_fb8d3080": "Your editor content is outdated. It is recommended to \"save\" the project first and then refresh the preview",
    "k_d5f96348": "There are changes to the backend code. Please \"save\" the project first and then refresh the preview",
    "k_5a8c0621": "AI backend service",
    "k_e55cc46e": "Call the backend service APIs developed in the AI editor, and the return value is axios response object ({ status, headers, data })",
    "k_d710cc37": "Request path",
    "k_2deca002": "Request configuration",
    "k_a52a4eb9": "Request body",
    "k_176d681e": "Duplicate path: {arg_0}",
    "k_987eef87": "Page ID {arg_0} is occupied by multiple paths: {arg_1}",
    "k_446752f6": "AI page path conflicts. Please modify the page path before saving.",
    "k_102bb28f": "Failed to generate backup path for occupied page path: {arg_0}",
    "k_b2357a57": "AI page path conflict: The page ID {arg_1} generated by path {arg_0} has been occupied by page {arg_2}(path: {arg_3}). Please modify the path before saving."
};
